import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

function HeatShrink() {
    const [active, setActive] = useState("Safe Area");
    const navigate = useNavigate();
    return (
        <>
        <Helmet>
    <title>
        Electrical Bulk Oil & Gas Products UAE | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar supplies certified electrical bulk products for oil and gas projects in the UAE, including LV and MV cables, cable glands, terminations, cable trays, lighting, control stations, socket outlets, earthing, lightning and electrical accessories."
    />

    <meta
        name="keywords"
        content="electrical bulk oil gas UAE, oil gas electrical products UAE, electrical supplies oil gas UAE, LV MV cables UAE, cable glands UAE, cable terminations UAE, hazardous area electrical products UAE, industrial lighting UAE, cable trays UAE, earthing materials UAE, oil gas electrical supplier UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/HeatShrink"
    />

    <meta
        property="og:title"
        content="Electrical Bulk Oil & Gas Products UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Certified electrical bulk supplies for oil and gas projects, including cables, glands, terminations, lighting, cable trays, earthing and electrical accessories across the UAE."
    />

    <meta
        property="og:url"
        content="https://saig.me/HeatShrink"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
           <div className='newbanner-about newbanner-about3'>
            <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Electrical Bulk - Oil & Gas</h6>
                <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Certified, time tested and approved range of products
                </p>
            </div>
        </div>

            <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  <h2>Electrical Bulk - Oil & Gas</h2>
  <div className='line'></div>

                         <h3 className='text-left mb-[20px]'>A one-stop electrical store for all the electrical bulk needs including cables. Partnering with us helps reduce supplier risk and the cost of handling multiple vendors. Our supplies are classified and certified to meet specific project requirements, vendor lists and global safety standards. Our team has extensive technical project management experience - where reliability and consistency are a priority</h3>


               </div>
               </div>
        

            <div className='detail-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[0px]'>

                <div className='detail-div-left'>

                    <div className='main-img'>

                        <img src='/assets/saigel.png' />
                    </div>


                </div>

          <div className='detail-div-right service-details-div2-new'>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Cables</h4>
  </div>
  <p>
    Power (LV & MV), earthing & control cables as per BS, IEC, CSA / UL / CE standards
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Cable Glands / Terminations</h4>
  </div>
  <p>
    Industrial, hazardous, barrier, EMC & thread conversion types
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Cable Tray and Support Systems</h4>
  </div>
  <p>
    Customised solutions in HDG, Aluminium, FRP & Stainless Steel
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Lighting</h4>
  </div>
  <p>
    LED, HID, flood, fluorescent, incandescent & emergency lighting solutions
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Lighting Poles</h4>
  </div>
  <p>
    Floodlight towers, straight & hinged poles in HDG & FRP
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Local Control Station</h4>
  </div>
  <p>
    Up to 81 operating elements in GRP, Stainless Steel & Aluminium enclosures
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Socket Outlets</h4>
  </div>
  <p>
    Industrial socket & welding outlets ranging from 16A to 600A
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Signalling Devices</h4>
  </div>
  <p>
    Audible, visual & combination devices, call points & grounding systems
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Earthing & Lightning Materials</h4>
  </div>
  <p>
    Early warning systems, early streamer emission, air terminals, down conductors, earth bars, earthing rods & accessories
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Exothermic Welding</h4>
  </div>
  <p>
    Graphite moulds, weld powder, handle clamps, tool-kit & mould jackets
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Electrical Accessories</h4>
  </div>
  <p>
    Cable lugs, connectors, grounding materials, cable ties, labelling, tapes, terminals, adhesives & fasteners
  </p>

</div>

            </div>








 <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>


                         <h3 className='text-left mb-[20px]'>Our knowledgeable staff can help you find the perfect products for your needs, so that you can rely on us to provide support through every stage of the project. The range is so vast that listing all the articles is impossible - please contact us for unlisted products.
<br/><br/>To ensure logistics we have tied with established freight forwarders undertaking Airfreights, FCL, LCL and chartered loads - ensuring totality !</h3>

  <Link to="/product">
                       <button className="backbtn mt-6">
                         Back To Products
                       </button>
                     </Link>
               </div>
               </div>




            <br />
            <br />
       
        </>
    )
}

export default HeatShrink